<template>
  <div class="container mt-4" dir="rtl">

    <!-- زر الطباعة (يختفي عند الطباعة) -->
    <div class="text-start mb-3 no-print">
      <button @click="print" class="btn btn-dark">
        <i class="fas fa-print"></i> طباعة الاستمارة
      </button>
    </div>

    <!-- منطقة الورقة (الطباعة) -->
    <div class="sheet-container p-4" id="printMe">
      
      <!-- 1. الترويسة -->
      <div class="header-section mb-4">
        <div class="row text-center align-items-center">
          <div class="col-4 text-start">
            <h6 class="fw-bold mb-1">محافظة: ........................</h6>
            <h6 class="fw-bold mb-1">مديرية التربية والتعليم</h6>
            <h6 class="fw-bold mb-0">لجنة النظام والمراقبة</h6>
          </div>
          
          <div class="col-4">
            <h3 class="fw-bold text-decoration-underline mb-2">استمارة متابعة أعمال الغرفة السرية</h3>
            <h5 class="fw-bold">(الشهادة الإعدادية / الثانوية)</h5>
          </div>

          <div class="col-4 text-start">
            <h6 class="fw-bold mb-1">الفصل الدراسي: ........................</h6>
            <h6 class="fw-bold mb-1">العام الدراسي: 2025 / 2026</h6>
            <h6 class="fw-bold mb-0">الدور: ........................</h6>
          </div>
        </div>
      </div>

      <!-- 2. بيانات المجموعة (بوكس بارز) -->
      <div class="group-info-box border border-2 border-dark p-3 mb-4 text-center rounded">
        <div class="row">
          <div class="col-6 border-start border-dark">
            <h4 class="fw-bold m-0">المادة: ........................................</h4>
          </div>
          <div class="col-6">
            <h4 class="fw-bold m-0">مجموعة رقم: ( .................... )</h4>
          </div>
        </div>
      </div>

      <!-- 3. جدول الأعمال (ثابت) -->
      <div class="table-responsive">
        <table class="table table-bordered border-dark align-middle text-center custom-table">
          <thead class="bg-light">
            <tr>
              <th width="5%">م</th>
              <th width="45%">بيان الأعمال والمهام</th>
              <th width="20%">توقيع العضو الأول</th>
              <th width="20%">توقيع العضو الثاني</th>
              <th width="10%">التاريخ</th>
            </tr>
          </thead>
          <tbody>
            <!-- الصف 1 -->
            <tr>
              <td>1</td>
              <td class="text-start pe-3 fw-bold">مراجعة ترصيد وتسلسل أرقام الجلوس</td>
              <td></td>
              <td></td>
              <td></td>
            </tr>
            <!-- الصف 2 -->
            <tr>
              <td>2</td>
              <td class="text-start pe-3 fw-bold">مراجعة كشوف المناداة مع بطاقات أرقام الجلوس</td>
              <td></td>
              <td></td>
              <td></td>
            </tr>
            <!-- الصف 3 -->
            <tr>
              <td>3</td>
              <td class="text-start pe-3 fw-bold">دق (وضع) الرقم السري على كراسات الإجابة</td>
              <td></td>
              <td></td>
              <td></td>
            </tr>
            <!-- الصف 4 -->
            <tr>
              <td>4</td>
              <td class="text-start pe-3 fw-bold">مراجعة الرقم السري (مطابقة القسيمة مع الغلاف)</td>
              <td></td>
              <td></td>
              <td></td>
            </tr>
            <!-- الصف 5 -->
            <tr>
              <td>5</td>
              <td class="text-start pe-3 fw-bold">تسجيل وحصر غياب المواد داخل المجموعة</td>
              <td></td>
              <td></td>
              <td></td>
            </tr>
            <!-- الصف 6 -->
            <tr>
              <td>6</td>
              <td class="text-start pe-3 fw-bold">مراجعة الغياب والخوارج للمجموعة الخاصة بهم</td>
              <td></td>
              <td></td>
              <td></td>
            </tr>
            <!-- الصف 7 -->
            <tr>
              <td>7</td>
              <td class="text-start pe-3 fw-bold">عمل إحصائيات كاملة عن المجموعة (حضور/غياب)</td>
              <td></td>
              <td></td>
              <td></td>
            </tr>
            <!-- الصف 8 -->
            <tr>
              <td>8</td>
              <td class="text-start pe-3 fw-bold">رصد الدرجات (الجزئيات) للمجموعة</td>
              <td></td>
              <td></td>
              <td></td>
            </tr>
            <!-- الصف 9 -->
            <tr>
              <td>9</td>
              <td class="text-start pe-3 fw-bold">مراجعة رصد الدرجات (مراجعة أولى - تجميع)</td>
              <td></td>
              <td></td>
              <td></td>
            </tr>
            <!-- الصف 10 -->
            <tr>
              <td>10</td>
              <td class="text-start pe-3 fw-bold">مراجعة رصد الدرجات (مراجعة ثانية - مرآة)</td>
              <td></td>
              <td></td>
              <td></td>
            </tr>
            <!-- الصف 11 -->
            <tr>
              <td>11</td>
              <td class="text-start pe-3 fw-bold">مراجعة رصد الدرجات (مراجعة ثالثة)</td>
              <td></td>
              <td></td>
              <td></td>
            </tr>
            <!-- الصف 12 -->
            <tr>
              <td>12</td>
              <td class="text-start pe-3 fw-bold">مراجعة نهائية لكل درجات المواد بالمجموعة</td>
              <td></td>
              <td></td>
              <td></td>
            </tr>
          </tbody>
        </table>
      </div>

      <!-- 4. التذييل والتوقيعات -->
      <div class="footer-section mt-5">
        <div class="row text-center">
          <div class="col-4">
            <h6 class="fw-bold mb-4">مسئول الغرفة السرية</h6>
            <p>.......................................</p>
          </div>
          <div class="col-4">
            <h6 class="fw-bold mb-4">وكيل الكنترول</h6>
            <p>.......................................</p>
          </div>
          <div class="col-4">
            <h6 class="fw-bold mb-4">رئيس لجنة النظام والمراقبة</h6>
            <p>.......................................</p>
          </div>
        </div>
      </div>

    </div>
  </div>
</template>

<script>
export default {
  name: "SecretRoomStaticSheet",
  methods: {
  print() {
      // Pass the element id here
      this.$htmlToPaper("printMe", () => {
        console.log("Printing done or got cancelled!");
      });
    },
  }
};
</script>

<style scoped>
/* إعدادات الصفحة الأساسية */
.sheet-container {
  background-color: white;
  min-height: 297mm; /* ارتفاع A4 */
}

/* تحسين الجدول */
.custom-table th {
  background-color: #f0f0f0 !important; /* لون رمادي فاتح للرأس */
  font-size: 1.1rem;
  padding: 10px;
}

.custom-table td {
  padding: 8px;
  height: 45px; /* ارتفاع مناسب للتوقيع */
  vertical-align: middle;
}

/* إعدادات الطباعة */
@media print {
  @page {
    size: A4;
    margin: 10mm;
  }

  body {
    background-color: white;
  }

  /* إخفاء زر الطباعة وأي عناصر أخرى */
  .no-print {
    display: none !important;
  }

  /* ضمان ظهور الحدود والألوان */
  .table-bordered th, 
  .table-bordered td,
  .border-dark {
    border: 1px solid black !important;
  }

  .bg-light {
    background-color: #f0f0f0 !important;
    -webkit-print-color-adjust: exact;
    print-color-adjust: exact;
  }
  
  /* إزالة أي هوامش افتراضية قد تخفي المحتوى */
  .container {
    width: 100%;
    max-width: 100%;
    margin: 0;
    padding: 0;
  }
}
</style>